<script setup lang="ts">
const { t } = useI18n();

defineProps<{
  tooltip: string;
}>();
</script>
<template>
  <div
    class="border border-error-700 rounded py-0.5 px-2 flex items-center bg-error-700 w-auto max-w-max"
    :title="tooltip"
  >
    <i-lxc-alert-triangle class="text-white w-4 mr-1" />
    <span class="text-xs text-white font-medium">{{
      t("license.gauge.device.error.message")
    }}</span>
  </div>
</template>
